import { setUseMemory } from '../state/index.js';
export function getSupportInCycle() {
    return setUseMemory.stateConfig.support;
}
export function setSupportInCycle(support) {
    return setUseMemory.stateConfig.support = support;
}
